import React, {useState, useEffect} from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { exportDayBookExcel } from "./ExportDayBookExcel";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from 'react-select';

//import { exportDayBookPDF } from "./ExportToPDF";

/*
 npm install file-saver
*/
const DetailBudgetReport = () => {

  const today = new Date().toISOString().split("T")[0];

  const [ddlSectionId, setDdlSectionId] = useState();
  const [paramFromDate, setParamFromDate] = useState(today);
  const [paramToDate, setParamToDate] = useState(today);
  const [bgtId, setBgtId] = useState();
  const [subBgtId, setSubBgtId] = useState();

  const [schoolName, setSchoolName] = useState();

  const [dayBookData, setDayBookData] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);
  const [budgetList, setBudgetList] = useState([]);
  const [subBudgetList, setSubBudgetList] = useState([]);

  

  // Pagination states
  // const [currentPage, setCurrentPage] = useState(1);
  // const recordsPerPage = 10;

  useEffect(() => {

    const fetchDropdowns = async () => {
      try {
        const [ SectionRes, bgtRes] =
          await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_sections`),
            axios.get(`${BASE_URL}/api/ddl_budget_master`),
          ]);

        setDdlSections(SectionRes.data);
         setBudgetList(bgtRes.data);

      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }

    };

    fetchDropdowns();
  }, []);

  useEffect(() => {

    const fetchSubBudget = async () => {
      try {
//console.log('bgtId ===> ', bgtId);
        setSubBgtId('');
        setSubBudgetList([]);
        if (bgtId) {
          const res = await axios.get(`${BASE_URL}/api/ddl_sub_budget_master`, { params: { p_Bdgt_Id: bgtId } });
          setSubBudgetList(res.data);
        }
      } catch (error) {
        console.error("Error fetching Division:", error);
      }
    };

    fetchSubBudget();

  }, [bgtId]);

  const handleRunReport = async () => {

    try {

      if (!bgtId || bgtId === '') {
        toast.error('Please select Budget.');
        return;
      } else if (!subBgtId || subBgtId === '') {
        toast.error('Please select Sub-Budget.');
        return;
      } else if (!paramFromDate || paramFromDate === '') {
        toast.error('Please enter From Date.');
        return;
      } else if (!paramToDate || paramToDate === '') {
        toast.error('Please enter To Date.');
        return;
      } else if (paramFromDate > paramToDate) {
        toast.error('From Date cannot be grater than To Date.');
        return;
      }

      const dayBookRes = await axios.get(`${BASE_URL}/api/rpt_detailed_budget`,
        { params: { p_Section_Id: ddlSectionId, p_FromDate: paramFromDate, p_ToDate: paramToDate, p_bgt_id: bgtId, p_sbgt_id: subBgtId } });

      if (dayBookRes.data.length > 0) {
        setDayBookData(dayBookRes.data);
        setSchoolName(dayBookRes.data[0].school_name);
      } else {
        setDayBookData([]);
        toast.error('No Record available');
      }

    } catch (error) {
     toast.error('Error Detailed Budget : ', error);
   }
 
  };

// // Group data by date
//   const groupedData = dayBookData.reduce((acc, curr) => {
//     if (!acc[curr.vchr_date]) acc[curr.vchr_date] = [];
//     acc[curr.vchr_date].push(curr);
//     return acc;
//   }, {});

//   // Calculate grand totals
//   const grandTotals = dayBookData.reduce(
//     (totals, item) => {
//       totals.dr += Number(item.dr_amt);
//       totals.cr += Number(item.cr_amt);
//       return totals;
//     },
//     { dr: 0, cr: 0 }
//   );

  const grandTotal = dayBookData.reduce(
    (total, item) => total + Number(item.amount || 0),
    0
  );
  /// Export to Excel
  const exportToExcel = () => {

    exportDayBookExcel({
      dayBookData,
      fromDate: paramFromDate,
      toDate: paramToDate,
      schoolName: schoolName,
    });

  };

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}/${month}/${year}`;
  };

  const budgetOptions = budgetList.map(code => ({
    value: code.bgt_id,
    label: code.bgt_name
  }));

  const subBudgetOptions = subBudgetList.map(sb => ({
    value: sb.sub_bgt_id,
    label: sb.sub_bgt_name
  }));

  return (
    <Container fluid className="p-3">
      {/* Header Section */}
      <Card className="mb-3 p-3">

        <Row className="mt-3">

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "140px" }}> Budget Name <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <div style={{ flex: 1 }}>

                <Select name="bgtId"
                  options={budgetOptions}
                  //className={`${errors.budget_id ? "is-invalid" : ""}`}
                  value={budgetOptions.find(option => option.value === bgtId) || null}
                  onChange={(selectedOption) =>
                    setBgtId(selectedOption ? selectedOption.value : '')}
                  placeholder="-- Select Budget --" />
              </div>
            </InputGroup>
          </Col>

          <Col md={6}>
            <InputGroup>
              <InputGroup.Text style={{ width: "160px" }}> Sub-Budget Name <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <div style={{ flex: 1 }}>

                <Select name="subBgtId"
                  options={subBudgetOptions}
                  //className={`${errors.budget_id ? "is-invalid" : ""}`}
                  value={subBudgetOptions.find(option => option.value === subBgtId) || null}
                  onChange={(selectedOption) =>
                    setSubBgtId(selectedOption ? selectedOption.value : '')}
                  placeholder="-- Select Budget --" />
              </div>
            </InputGroup>
          </Col>

        </Row>

        <Row className="mt-3">

          <Col md={3}>
            <InputGroup >
              <InputGroup.Text>Section</InputGroup.Text>
              <select className="form-select" name="ddlSectionId" value={ddlSectionId}
                onChange={(e) => setDdlSectionId(e.target.value)} >
                <option value="">-- Select Section --</option>
                {ddlSections.map(sec => (
                  <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                ))}
              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup >
              <InputGroup.Text style={{width: "140px"}}>From/To Date <span style={{ color: "red" }}>*</span></InputGroup.Text>
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramFromDate}
              onChange={(e) => setParamFromDate(e.target.value)}
            />
            <input
              type="date" style={{textAlign: 'right'}}
              className="form-control"
              value={paramToDate}
              onChange={(e) => setParamToDate(e.target.value)}
            />
            </InputGroup>
          </Col>

          <Col md={5} className="d-flex justify-content-end">
            {/* <Button style={{height: '40px', width: '145px'}} className="me-2" variant="secondary" 
                    onClick={exportToExcel} disabled={dayBookData.length === 0}>Download Excel</Button>
            <Button style={{height: '40px', width: '135px'}} className="me-2" variant="warning" 
                    onClick={handleDownloadPDF} disabled={dayBookData.length === 0}>Download PDF</Button> */}
            <Button style={{height: '40px', width: '135px'}} className="me-2" variant="success" 
                    onClick={handleRunReport} >Run Report</Button>

          </Col>
        </Row>

      </Card>

      {/* Details Table */}
      <Card className="p-3">
        <div style={{ minHeight: '380px' }} className="table-responsive">

          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table-rcpt hover-table-rcpt">

            <thead className="table-light">
              <tr>
                <th style={{ textAlign: 'center', width: '10%' }}> Section </th>
                <th style={{ textAlign: 'center', width: '8%' }}> Date </th>
                <th style={{ textAlign: 'center', width: '8%' }}> Vchr No </th>
                <th style={{ textAlign: 'left', width: '20%' }}> Account </th>
                <th style={{ textAlign: 'left', width: '12%' }}> Paid To </th>
                <th style={{ textAlign: 'left', width: '35%' }}> Narration </th>
                <th style={{ textAlign: 'right', width: '12%' }}> Amount </th>
              </tr>
            </thead>

            <tbody>

              {dayBookData.length > 0 ? (
                <>
                  {dayBookData.map((dbook, idx) => (

                    <tr key={`${dbook.vchr_no}-${idx}`}>

                      <td style={{ textAlign: 'center' }}> {dbook.sec_prefix} </td>
                      <td style={{ textAlign: 'center' }}> {dbook.vchr_date} </td>
                      <td style={{ textAlign: 'center' }}> {dbook.vchr_no} </td>
                      <td style={{ textAlign: 'left' }}> {dbook.cb_acct_name} </td>
                      <td style={{ textAlign: 'left' }}> {dbook.paid_to || ''} </td>
                      <td style={{ textAlign: 'left' }}> {dbook.narration} </td>
                      <td className="text-end">
                        {Number(dbook.amount || 0).toLocaleString(
                          'en-IN',
                          { minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }
                        )}
                      </td>

                    </tr>

                  ))}

                  {/* FINAL TOTAL */}
                  <tr style={{ fontWeight: 'bold', backgroundColor: '#dcdcdc' }} >

                    <td colSpan="6" className="text-end" style={{ paddingRight: '10px' }} > TOTAL: </td>

                    <td className="text-end">
                      {grandTotal.toLocaleString(
                        'en-IN',
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }
                      )}
                    </td>

                  </tr>
                </>

              ) : (

                <tr>
                  <td colSpan="7" className="text-center">
                    No Data found.
                  </td>
                </tr>

              )}

            </tbody>

          </table>

        </div>
      </Card>

    </Container>
  );
};

export default DetailBudgetReport;
